export default "__VITE_ASSET__FBftxW0H__"